import {
    Card,
    Flex, Space
} from "antd";
import React, {useCallback, useState} from "react";
import {aiChainPrompt} from "../../Prompt";
import TextArea from "antd/es/input/TextArea";
import {ModelsMenu} from "../../components/ModelsMenu";
import {LanguagesGroup} from "../../components/LanguagesGroup";
import {ListResults} from "../../components/ListResults";
import {GenButton} from "../../components/GenButton";
import {generateOtherNamePrompt} from "../ToolsPrompts";
import {useParams} from "react-router-dom";

export const OtherNameGenerator = (props: {
    onItemClick?: (item: any) => void
}) => {
    const [description, setDescription] = useState("");
    const [languages, setLanguages] = useState(["Russian"]);
    const [names, setNames] = useState([]);
    const [switchLangs, setSwitchLangs] = useState<string[]>([]);
    const [height, setHeight] = useState(0);

    const elementRef = useCallback((node: any) => {
        if (!node) return;
        const resizeObserver = new ResizeObserver(() => {
            setHeight(node.getBoundingClientRect().height);
        });
        resizeObserver.observe(node);
    }, []);

    return (
        <Flex gap={16} style={{width: "100%"}}>
            <Flex vertical={true} gap={10} style={{height: "100%", width: 300}} ref={elementRef}>
                <ModelsMenu/>
                <Card title={"Description"}>
                    <TextArea
                        placeholder={"e.g Name of an artifact that makes time stop"}
                        value={description}
                        rows={5}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </Card>
                <Card title={"Languages"}>
                    <LanguagesGroup
                        languages={languages}
                        onChange={setLanguages}
                    />
                </Card>
                <GenButton
                    style={{width: "100%"}}
                    type={'primary'}
                    actions={[{
                        key: "1",
                        title: "Generate",
                        action: async (model: string, projectId: string) =>
                            aiChainPrompt({
                                projectId: projectId ?? '',
                                prompt: generateOtherNamePrompt(
                                    {
                                        description: description,
                                        translations: languages,
                                    }
                                ),
                                model: model,
                                type: "json"
                            }).then((response) => {
                                setNames(response.data)
                                setSwitchLangs(languages)
                            }).catch((e) => {
                                console.log(e)
                            })
                    }]}/>
            </Flex>
            <ListResults
                items={names}
                onItemClick={props.onItemClick}
                height={height}
                languages={switchLangs}
            />
        </Flex>
    );
}